// extracted by mini-css-extract-plugin
export default {"card":"ReportCard_card__-I8EG","innerCard":"ReportCard_innerCard__TcNmD","btn":"ReportCard_btn__y09C7","bordered":"ReportCard_bordered__qXbVu"};